import React from 'react';
import styled from 'styled-components';
import { themes } from 'styles/themes/wikifactoryNew';

export const DropdownWrapper = styled.div(({ theme }) => ({
  [`@media(max-width: ${theme.breakpoints.medium})`]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const placeholderStyle: React.CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: '#777',
};

export const dropTriggerStyle: React.CSSProperties & {
  hoverStyle: React.CSSProperties;
} = {
  borderRadius: 'none',
  display: 'flex',
  alignItems: 'center',
  hoverStyle: {
    background: 'none',
    opacity: 0.8,
  },
};

export const dropItemStyle: React.CSSProperties = {
  fontSize: themes.font.size.small,
};
